import { call, put, takeLatest } from "redux-saga/effects";
import { AxiosResponse } from "axios";
import { toast } from "react-toastify";
import {
    getCustomerSuccess as getCustomerSuccessService,
    getCustomerSuccessBenchmarks as getCustomerSuccessBenchmarksService,
    getImplementationOverview as getImplementationOverviewService,
    getLivePortfolio as getLivePortfolioService,
    getIntegrationsReport as getIntegrationsReportService,
    getOverdueWeek as getOverdueWeekService,
    getReportSettings as getReportSettingsService,
    updateReportSettings as updateReportSettingsService,
} from "../../services/reports/reports.service";
import {
    getCustomerSuccess,
    getCustomerSuccessBenchmarks,
    getCustomerSuccessBenchmarksFailure,
    getCustomerSuccessBenchmarksSuccess,
    getCustomerSuccessFailure,
    getCustomerSuccessSuccess,
    getImplementationOverview,
    getImplementationOverviewFailure,
    getImplementationOverviewSuccess,
    getLivePortfolio,
    getLivePortfolioFailure,
    getLivePortfolioSuccess,
    getIntegrationsReport,
    getIntegrationsReportFailure,
    getIntegrationsReportSuccess,
    getOverdueWeek,
    getOverdueWeekFailure,
    getOverdueWeekSuccess,
    getReportSettings,
    getReportSettingsFailure,
    getReportSettingsSuccess,
    updateReportSettings,
    updateReportSettingsFailure,
    updateReportSettingsSuccess,
} from "../reducer/reports";
import { GetCustomerSuccessBenchmarksAction, GetLivePortfolioAction, GetOverdueWeekAction, ReportFailurePayload, UpdateReportSettingsAction } from "../types/reports";

const failureOf = (error: any): ReportFailurePayload => ({ status: error?.response?.status ?? error?.status });

function* getImplementationOverviewSaga() {
    try {
        const { data }: AxiosResponse = yield call(getImplementationOverviewService);
        yield put(getImplementationOverviewSuccess(data));
    } catch (error) {
        yield put(getImplementationOverviewFailure(failureOf(error)));
    }
}

function* getOverdueWeekSaga(action: GetOverdueWeekAction) {
    try {
        const { data }: AxiosResponse = yield call(getOverdueWeekService, action.payload);
        yield put(getOverdueWeekSuccess(data));
    } catch (error) {
        yield put(getOverdueWeekFailure(failureOf(error)));
    }
}

function* getIntegrationsReportSaga() {
    try {
        const { data }: AxiosResponse = yield call(getIntegrationsReportService);
        yield put(getIntegrationsReportSuccess(data));
    } catch (error) {
        yield put(getIntegrationsReportFailure(failureOf(error)));
    }
}

function* getReportSettingsSaga() {
    try {
        const { data }: AxiosResponse = yield call(getReportSettingsService);
        yield put(getReportSettingsSuccess(data));
    } catch (error) {
        yield put(getReportSettingsFailure(failureOf(error)));
    }
}

function* updateReportSettingsSaga(action: UpdateReportSettingsAction) {
    try {
        const { data }: AxiosResponse = yield call(updateReportSettingsService, action.payload);
        yield put(updateReportSettingsSuccess(data));
        toast.success("Report settings saved. Reports use them from their next load.");
    } catch (error) {
        yield put(updateReportSettingsFailure(failureOf(error)));
    }
}

function* getLivePortfolioSaga(action: GetLivePortfolioAction) {
    try {
        const { data }: AxiosResponse = yield call(getLivePortfolioService, action.payload);
        yield put(getLivePortfolioSuccess(data));
    } catch (error) {
        yield put(getLivePortfolioFailure(failureOf(error)));
    }
}

function* getCustomerSuccessSaga() {
    try {
        const { data }: AxiosResponse = yield call(getCustomerSuccessService);
        yield put(getCustomerSuccessSuccess(data));
    } catch (error) {
        yield put(getCustomerSuccessFailure(failureOf(error)));
    }
}

function* getCustomerSuccessBenchmarksSaga(action: GetCustomerSuccessBenchmarksAction) {
    try {
        const { data }: AxiosResponse = yield call(getCustomerSuccessBenchmarksService, action.payload.organizationId, action.payload.compare);
        yield put(getCustomerSuccessBenchmarksSuccess(data));
    } catch (error) {
        yield put(getCustomerSuccessBenchmarksFailure(failureOf(error)));
    }
}

export function* rootSaga() {
    yield takeLatest(getImplementationOverview.type, getImplementationOverviewSaga);
    yield takeLatest(getOverdueWeek.type, getOverdueWeekSaga);
    yield takeLatest(getIntegrationsReport.type, getIntegrationsReportSaga);
    yield takeLatest(getReportSettings.type, getReportSettingsSaga);
    yield takeLatest(updateReportSettings.type, updateReportSettingsSaga);
    // Latest wins, so a quick period change never shows an older period's figures
    yield takeLatest(getLivePortfolio.type, getLivePortfolioSaga);
    yield takeLatest(getCustomerSuccess.type, getCustomerSuccessSaga);
    yield takeLatest(getCustomerSuccessBenchmarks.type, getCustomerSuccessBenchmarksSaga);
}
